/* eslint-disable */
export const settings = {
	app: {
		name: 'Hope Academy',
		version: '1.0.0'
	},
	theme: {
		skin: 'light' // possible values are light, dark
	}
};
export default { settings };
